'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState } from 'react';
import { sendAnalyticsData } from '@/src/utils/analytics';
import type { IContactUs } from './Contactus';
import HubSpotMeeting from './HubSpotMeeting';
interface IProps {
  formData?: IContactUs | null;
}
const ThankyouPage = t0 => {
  const $ = _c(7);
  const {
    formData
  } = t0;
  const [showSchedulePage, setShowSchedulePage] = useState(false);
  if (showSchedulePage) {
    let t1;
    if ($[0] !== formData) {
      t1 = <HubSpotMeeting formData={formData} />;
      $[0] = formData;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto flex h-20 w-28 items-center justify-center"><Image src="/images/Formsubmitted.svg" alt="Form Submitted" width={100} height={120} /></div>;
    t2 = <h1 className="select-none text-3xl font-bold text-gray-800">Form Submitted</h1>;
    t3 = <p className="text-md select-none font-bold text-gray-700">We will get back to you within 24 hours.</p>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>{t1}{t2}{t3}<p className="mt-4 select-none text-sm text-gray-600">If you'd like to set a specific time to connect,<br />feel free to schedule a meeting.</p></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex min-h-screen items-center justify-center bg-white px-4"><div className="w-full max-w-md text-center">{t4}<div className="mt-8"><button onClick={() => {
            setShowSchedulePage(true);
            sendAnalyticsData("SCHEDULE_MEETING_BUTTON_CLICKED");
          }} className="rounded-md bg-blue-50 px-6 py-2 text-base font-medium text-blue-500 transition-colors hover:bg-blue-100">Schedule a Meeting</button></div></div></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default ThankyouPage;